import React from 'react';
import { useCart } from 'react-use-cart';
import '../Components/Itemcard/style.css';


export const Cart = () => {
    let {
        isEmpty,
        totalUniqueItems,
        items,
        totalItems,
        cartTotal,
        updateItemQuantity,
        removeItem,
        emptyCart,
    } = useCart();

    if (isEmpty) return <h4 className='emptycart'> Your Cart is Empty <br></br><span>Please add any Items</span></h4>
    return (
        <section className='py-4 container'>
            <div className='row justify-content-center'>
                <div className="col-12">

                    <table className='table table-light table-hover mt-5'>
                        <tbody>
                        {items.map((item, index) => {
                        return (
                        <tr key={index}>
                        <td>
                        <img src={item.img} style={{width:'200px'}} />
                        </td>
                        <td className='tds'>{item.title}</td>
                        <td className='tds'>{item.price}</td>
                        <td className='tds'>Quantity {item.quantity}</td>
                        <td className='btns tds'>
                        <button className="btn btn-outline-danger ms-4" onClick={() => updateItemQuantity(item.id, item.quantity - 1)} >-</button>
                        <button className="btn btn-outline-success ms-4" onClick={() => updateItemQuantity(item.id, item.quantity + 1)}>+</button>
                        <button className="btn btn-remove btn-outline-danger ms-4" onClick={() => removeItem(item.id, item.quantity + 1)}>Remove</button>
                        </td></tr>
                        )
                        })}
                        </tbody>
                    </table>
                </div>
                <h5>Products : {totalUniqueItems} & Total Items : {totalItems} </h5>
                <div className=' tp mt-5'>
                <h2>Total Price : ₹ {cartTotal}.00</h2>
                </div>
                <div className="clearbtn mt-3">
                <button className="btn btnpay btn-success">PayNow</button>
                <button className='btn btnrem btn-danger' onClick={() => emptyCart()}>Clear All</button>
                </div>
            </div>
        </section>

    )
}
